import styled from 'styled-components';

export const Container = styled.div`
  padding: 1.5rem;
  height: 100%;
`;

export const StoresPanel = styled.div`
  border-radius: 0.25rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  position: relative;

  .pageTitle {
    display: flex;
    justify-content: center;
    margin-bottom: 2.2rem;

    .backIcon {
      color: ${({ theme }) => theme.button_high};
      font-size: 1.5rem;
    }

    h2 {
      margin-left: 0;
    }
  }
  .periodo {
    margin: 1.875rem 0 0.375rem;
  }

  .loading {
    width: 100%;
    display: flex;
    justify-content: center;
    position: absolute;
  }

  .tableActions {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    div {
      border: 0ch;
    }
    .input {
      height: 2.0625rem;
      margin: 0;
    }
    .calendar {
      border-radius: 0.5rem;
      background-color: ${({ theme }) => theme.background_high};
    }
  }

  .pageMenu {
    width: 100%;
    height: 5rem;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;

    .pageNumber {
      margin: 0 1rem;
      border-radius: 100%;
      background-color: ${({ theme }) => theme.background_secondary};
      width: 1.25rem;
      height: 1.25rem;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      p {
        font-size: 0.75rem;
        color: ${({ theme }) => theme.font_primary};
      }
    }
  }
`;

export const StoresTable = styled.div`
  margin-top: 1.5rem;
  width: 100%;

  .pillOptions {
    display: grid;
    grid-template-columns: 1fr 1fr 0.7fr 1fr 0.7fr repeat(2, 1fr) 0.2fr;
    padding: 0 1rem 0 1rem;
    position: absolute;

    .options {
      background-color: ${({ theme }) => theme.background_primary};
      border-radius: 0.25rem;
      box-shadow: 0.625rem 0.313rem 0.313rem
        ${({ theme }) => theme.background_low};

      hr {
        width: '80%';
        margin-left: '10%';
        margin-right: '10%';
      }
      .option {
        margin: 0.625rem;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        .MuiCheckbox-colorPrimary {
          color: ${({ theme }) => theme.button_high};
        }
        .MuiCheckbox-root {
          padding-right: 0.25rem;
        }
      }
    }
  }
`;

export const OrdersHeader = styled.div`
  margin-top: 0.5rem;
  width: 100%;

  .header {
    background-color: ${({ theme }) => theme.background_secondary};
    border-top: 0.063rem solid ${({ theme }) => theme.background_secondary};
    border-bottom: 0.063rem solid ${({ theme }) => theme.background_secondary};
    padding: 0.5rem 1rem;
    display: grid;
    grid-template-columns: 0.5fr repeat(6, 1fr);

    div {
      display: flex;
      justify-content: flex-start;
      align-items: center;

      p {
        color: ${({ theme }) => theme.background_low};
        border: none;
        padding: 0;
        font-weight: 700;
        margin-right: 0.5rem;
      }

      button {
        font-size: 1rem;
        display: flex;
        justify-content: flex-end;
        align-items: center;
      }
    }
  }

  .rowTable {
    padding: 0.5rem 1rem;
    display: grid;
    grid-template-columns: 0.5fr repeat(6, 1fr);
    border-bottom: 0.063rem solid ${({ theme }) => theme.background_secondary};

    div {
      display: flex;
      flex-direction: column;
      justify-content: center;

      .hourSection {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;

        .hourSectionInfo {
          margin-left: 0.5rem;

          .hour {
            font-size: 0.625rem;
            color: ${({ theme }) => theme.font_secondary};
          }
        }
      }

      .numberCode {
        color: ${({ theme }) => theme.font_secondary};
      }

      .price {
        font-weight: 700;
      }

      .productQuantity {
        color: ${({ theme }) => theme.font_secondary};
        font-size: 0.75rem;
      }
    }

    .detailsButton {
      font-size: 2rem;
      padding: 0.25rem 0.625rem;
    }
  }
`;

export const DetailsPanel = styled.div`
  background-color: ${({ theme }) => theme.background_primary};
  width: 100%;
  padding: 0.5rem;
  border-radius: 0.25rem;
  display: grid;
  grid-template-columns: 14fr 1fr 13fr 1fr 14fr;
  height: 20rem;

  .sectionPanel {
    display: flex;
    flex-direction: column;
    min-height: -webkit-fill-available;

    .rolagem2 {
      margin-top: 0.125rem;
      height: 100%;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      overflow-y: scroll;
      padding-right: 0.25rem;

      /* width */
      ::-webkit-scrollbar {
        width: 0.25rem;
      }
      /* Track */
      ::-webkit-scrollbar-track {
        background: none;
      }
      /* Handle */
      ::-webkit-scrollbar-thumb {
        background: ${({ theme }) => theme.background_secondary};
        border-radius: 0.25rem;
      }
      /* Handle on hover */
      ::-webkit-scrollbar-thumb:hover {
        background: #555;
      }
    }

    .sectionPanelTitle {
      display: flex;
      font-weight: 700;
      font-size: 1.125rem;
      color: ${({ theme }) => theme.background_secondary};

      .sectionPanelTitleSecondary {
        margin-left: 2rem;
        color: ${({ theme }) => theme.background_high};
      }

      .pill {
        font-weight: 400;
        font-size: 0.875rem;
        margin-left: 1.5rem;
        color: ${({ theme }) => theme.background_high};
      }
    }

    .sectionContent {
      display: flex;
      flex-direction: column;
      height: 100%;
      padding: 0.625rem;

      .sectionSubContentVertical {
        display: flex;
        flex-direction: column;

        .sectionSubContentTitle {
          font-weight: 700;
          font-size: 0.875rem;
          padding-bottom: 0.5rem;
          border-bottom: ${({ theme }) => theme.background_secondary} solid
            0.063rem;
        }

        .sectionSubContentInfo {
          font-size: 0.875rem;

          p {
            margin: 0.5rem 0 0.5rem;
          }
        }
      }

      .sectionSubContentHorizontal {
        display: flex;
        border-bottom: ${({ theme }) => theme.background_secondary} solid
          0.125rem;
        padding-bottom: 0.5rem;

        .sectionSubContentInfo {
          margin-right: 1rem;

          .title {
            display: flex;
            align-items: center;
            font-weight: 700;
            font-size: 0.75rem;
            margin-bottom: 0.5rem;

            p {
              margin-left: 0.25rem;
            }
          }

          .valueText {
            display: flex;
            align-items: center;
            font-weight: 700;
            font-size: 0.75rem;
            margin-bottom: 0.5rem;

            p {
              margin: 0 0.25rem;
            }
          }
        }
      }

      .sectionSubContentIntegration {
        display: flex;
        flex-direction: column;

        .sectionSubContentIntegrationTitle {
          font-weight: 700;
          font-size: 0.875rem;
          margin-bottom: 0.875rem;
        }

        .sectionSubContentIntegrationContent {
          display: flex;
          justify-content: space-between;

          .sectionSubContentIntegrationContentText {
            display: flex;
            flex-direction: column;

            P {
              margin-bottom: 0.75rem;
            }

            .integratedPackageIn {
              font-weight: 500;
              font-size: 0.875rem;
              color: ${({ theme }) => theme.button_success};
            }

            .canceledIn {
              font-weight: 500;
              font-size: 0.875rem;
              color: ${({ theme }) => theme.button_danger};
            }
          }

          .sectionSubContentIntegrationContentInfo {
            display: flex;
            flex-direction: column;

            P {
              margin-bottom: 0.75rem;
            }

            .integratedPackageIn {
              font-weight: 500;
              font-size: 0.875rem;
              color: ${({ theme }) => theme.button_success};
            }

            .canceledIn {
              font-weight: 500;
              font-size: 0.875rem;
              color: ${({ theme }) => theme.button_danger};
            }
          }
        }

        .sectionSubContentProductCard {
          width: 100%;
          display: flex;
          justify-content: space-between;
          background-color: ${({ theme }) => theme.background_primary};
          border-radius: 0.25rem;
          margin-bottom: 0.5rem;
          box-shadow: 0px 0.25rem 0.25rem rgba(0, 0, 0, 0.25);

          .productInfo {
            display: flex;
            flex-direction: column;
            width: 100%;
            justify-content: space-between;
            padding: 0.75rem;

            .productInfoTitle {
              font-size: 1rem;
            }

            .productRef {
              font-size: 0.75rem;
              color: ${({ theme }) => theme.button_secondary};
            }

            .price {
              display: flex;

              .originalPrice {
                font-size: 0.875rem;
                text-decoration-line: line-through;
                margin-right: 1rem;
              }

              .currentPrice {
                font-weight: 700;
                font-size: 0.875rem;
                color: ${({ theme }) => theme.font_danger};
              }
            }

            .productInfoFooter {
              display: flex;
              justify-content: space-between;

              .productDeadline {
                font-weight: 700;
                font-size: 0.875rem;
              }

              .productQuantity {
                font-weight: 700;
                font-size: 0.875rem;
              }
            }
          }
          .imageSection {
            width: 7rem;
            img {
              max-width: -webkit-fill-available;
            }
          }
        }
      }

      .rolagem {
        margin-top: 0.125rem;
        height: 65%;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        overflow-y: scroll;
        padding-right: 0.25rem;
        /* width */
        ::-webkit-scrollbar {
          width: 0.25rem;
        }
        /* Track */
        ::-webkit-scrollbar-track {
          background: none;
        }
        /* Handle */
        ::-webkit-scrollbar-thumb {
          background: ${({ theme }) => theme.background_secondary};
          border-radius: 0.25rem;
        }
        /* Handle on hover */
        ::-webkit-scrollbar-thumb:hover {
          background: #555;
        }

        .sectionSubContentPaymentType {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          height: 100%;

          .sectionSubContentPaymentTypeTitle {
            margin-top: 0.5rem;
            display: flex;
            align-items: center;
            font-weight: 700;
            font-size: 1rem;
            color: ${({ theme }) => theme.background_secondary};

            .paymentType {
              margin-right: 0.25rem;
            }

            .paymentTypeContent {
              font-size: 0.875rem;
              color: ${({ theme }) => theme.background_high};
            }
          }

          .sectionSubContentPaymentTypeContent {
            display: flex;
            margin-top: 0.5rem;
            margin-bottom: 0.5rem;

            .sectionSubContentPaymentTypeContentInfo {
              margin-right: 1rem;
              display: flex;

              .text {
                display: flex;
                flex-direction: column;
                margin-left: 0.25rem;

                .title {
                  color: ${({ theme }) => theme.background_secondary};
                  font-weight: 500;
                  font-size: 0.625rem;
                }

                .hour {
                  color: ${({ theme }) => theme.background_secondary};
                  font-size: 0.625rem;
                  font-weight: 400;
                }
              }
            }
          }

          .sectionSubContentPaymentTypeModals {
            display: flex;
            flex-direction: column;

            .sectionSubContentPaymentTypeModalsTitle {
              display: flex;
              font-weight: 700;
              font-size: 1.125rem;
              margin-bottom: 1rem;

              .text {
                margin-right: 0.25rem;
              }
            }

            .sectionSubContentPaymentTypeModalsContent {
              display: flex;
              justify-content: space-between;

              .modalButton {
                height: 3rem;
                width: 8.5rem;
                border: ${({ theme }) => theme.background_secondary} 0.063rem
                  solid;
                border-radius: 0.5rem;
                display: flex;
                justify-content: center;
                align-items: center;

                .modalButtonIcon {
                  color: ${({ theme }) => theme.font_secondary};
                }

                p {
                  color: ${({ theme }) => theme.font_high};
                  font-weight: 700;
                  font-size: 0.75rem;
                  margin-left: 0.5rem;
                }
              }
            }
          }
        }
      }
    }
  }
`;
